













































































































































































































































import { Vue, Component, Mixins, Ref, Watch } from 'vue-property-decorator';
// @ts-ignore hack
import TableMixin from '@root/common/mixins/table';
// @ts-ignore hack
import TableWidthMixin from '@root/common/mixins/table-width';
// @ts-ignore hack
import GoBackWithCloseTabMixin from '@root/common/mixins/go-back-with-close-tab';
import ParkingLotSearch from '../../../components/parking-lot-search/index.vue';
import PayRecordSelect from './components/pay-record-select.vue';
import BankSelect from './components/bank-select.vue';
import moment from 'moment';
import * as api from '../../../api/reconciliation-management';
import { IPayRecordSelect, IBankSelect } from './components/types';
import _ from 'lodash';

@Component({
  components: {
    ParkingLotSearch,
    PayRecordSelect,
    BankSelect
  }
})
export default class CashPageCreate extends Mixins(TableMixin, TableWidthMixin, GoBackWithCloseTabMixin) {
  path = '/smart-parking/reconciliation-management/cash-page/';
  // 是否冲销
  cancel: boolean = false;
  // 冲销原型，只在冲销状态下填写
  cancelReason: string = '';
  form: any = null;
  // 面包屑
  get navs() {
    return [
      {
        label: '存现单管理',
        location: {
          name: 'cash-page'
        }
      },
      {
        label: this.$route.meta.title
      }
    ];
  }

  @Ref()
  readonly panel!: Vue;
  getPopupContainer() {
    return this.panel.$el;
  }

  initForm() {
    this.form = this.$form.createForm(this, {
      mapPropsToFields: () => {
        return {
          bankReceiptNo: this.$form.createFormField({ value: '' }),
          receiptTime: this.$form.createFormField({ value: '' }),
          amounts: this.$form.createFormField({ value: '' }),
          parkId: this.$form.createFormField({ value: '' }),
          projectBankNo: this.$form.createFormField({ value: '' }),
          remark: this.$form.createFormField({ value: '' }),
          attachFileUrl: this.$form.createFormField({ value: '' })
        };
      }
    });
  }

  uploadingFile: any = null;
  uploadingStatus: string = '';
  checkFile(file: { size: number }) {
    // 文件大小限制
    if (file.size > 2097152) {
      return '上传附件不能超过2MB';
    }
  }
  beforeUpload(file: { size: number }) {
    const err = this.checkFile(file);
    // 文件大小限制
    if (err) {
      this.$message.error(err);
      return false;
    }
    return true;
  }
  getValueFromEvent(e: any) {
    const err = this.checkFile(e.file);
    if (err) {
      return '';
    }
    this.uploadingFile = e.file;
    this.uploadingStatus = e.file.status;
    if (e.file && e.file.response && e.file.response.data) {
      return e.file.response.data;
    }
  }
  upload(params: { file: string | Blob; onSuccess: (arg0: any) => void; onError: (arg0: any) => void }) {
    console.log(params);
    const formData = new FormData();
    formData.append('file', params.file);
    api
      .upload(formData)
      .then((res: { status: string }) => {
        if (res.status == '9999') {
          params.onSuccess(res);
        } else {
          this.$message.error('文件上传失败，请重试');
          params.onError(res);
        }
      })
      .catch((err: any) => {
        this.$message.error('文件上传失败，请重试');
        params.onError(err);
      });
  }

  removeFile() {
    this.uploadingFile = null;
    this.uploadingStatus = '';
    this.form.setFieldsValue({
      attachFileUrl: ''
    });
  }

  selectPark: any = null;
  parkChange(e: any) {
    this.selectPark = e;
    // 清空缴费记录
    this.selectedRecordIdList = [];
    this.tableDataAll = [];
    this.tableData = [];
    this.current = 1;
    this.total = 0;
  }

  //银行账号选择
  @Ref()
  readonly bankSelect!: IBankSelect;
  selectedBank: any = null;
  bankSelectModalVisible: boolean = false;
  openBankSelectModal() {
    this.bankSelectModalVisible = true;
  }
  handleBankSelectModalCancel() {
    this.bankSelectModalVisible = false;
  }
  handleBankSelectModalConfirm() {
    this.selectedBank = this.bankSelect.getSelectedBank();
    if (this.selectedBank) {
      this.form.setFieldsValue({
        projectBankNo: this.selectedBank.bankNo
      });
    }
    this.bankSelectModalVisible = false;
  }

  easPayRecordModalVisible: boolean = false;
  openEasPayRecordModal() {
    if (!this.form.getFieldValue('parkId')) {
      this.$message.error('请先选择车场');
      return;
    }
    this.easPayRecordModalVisible = true;
  }
  handleEasPayRecordModalCancel() {
    this.easPayRecordModalVisible = false;
  }

  @Ref()
  readonly payRecordSelect!: IPayRecordSelect;
  handleEasPayRecordModalConfirm() {
    const list = this.payRecordSelect.getSelectedRecordIdList();
    this.tableDataAll.splice(0, 0, ...list);
    this.selectedRecordIdList = this.tableDataAll.map(i => i.easPayRecordId);
    this.current = 1;
    this.pageTable();
    // 清除选中
    this.selectedRowKeys = [];
    this.easPayRecordModalVisible = false;
  }

  get tableColums() {
    return [
      // {
      //   title: '序号',
      //   width: 80,
      //   customRender: (text: any, record: any, index: number) => {
      //     if (record.isTotal === true) {
      //       return '合计'
      //     }
      //     return `${(this.current - 1) * this.pageSize + index + 1}`
      //   },
      // },

      {
        title: '费用类型',
        dataIndex: 'bizType'
      },
      {
        title: '支付方式',
        dataIndex: 'payMethod'
      },
      {
        title: '金额',
        dataIndex: 'paidPrice',
        customRender: this.numberRender
      },
      {
        title: '缴款人',
        dataIndex: 'payer'
      },
      {
        title: '收款人',
        dataIndex: 'payee'
      },
      {
        title: '交易时间',
        dataIndex: 'tradeTime',
        width: 200
      },
      {
        title: '费用期间',
        dataIndex: 'tradeDay'
      },
      {
        title: '操作',
        dataIndex: 'operation',
        fixed: 'right',
        width: 100,
        scopedSlots: { customRender: 'operation' }
      }
    ];
  }

  current: number = 1;
  pageSize: number = 10;
  total: number = 0;
  tableDataAll: any[] = [];
  tableData: any[] = [];
  tableLoading: boolean = false;
  selectedRowKeys: string[] = [];
  // 已选择的缴费id
  selectedRecordIdList: string[] = [];

  pageTable() {
    this.total = this.tableDataAll.length;
    const start = (this.current - 1) * this.pageSize;
    const end = start + this.pageSize;
    this.tableData = this.tableDataAll.slice(start, end);
  }

  showSizeChangerChange(current: any, pageSize: any) {
    this.current = current;
    this.pageSize = pageSize;
    this.pageTable();
  }

  onSelectAll(selected: any, selectedRows: any, changeRows: any) {
    if (selected) {
      this.selectedRowKeys = this.tableDataAll.map(i => i.easPayRecordId);
    } else {
      this.selectedRowKeys = [];
    }
  }
  onSelectChange(selectedRowKeys: string[], selectedRows: any) {
    this.selectedRowKeys = selectedRowKeys;
  }

  removeRecord(record: any) {
    const index = this.tableDataAll.findIndex(i => i == record);
    this.tableDataAll.splice(index, 1);
    this.selectedRecordIdList = this.tableDataAll.map(i => i.easPayRecordId);
    this.pageTable();
  }

  removeRecords() {
    if (!this.selectedRowKeys.length) {
      this.$message.warning('您未选择任何记录！');
      return;
    }
    this.$confirm({
      title: '提示',
      content: '您确定要删除这些记录吗？',
      onOk: () => {
        this.tableDataAll = this.tableDataAll.filter(i => !_.includes(this.selectedRowKeys, i.easPayRecordId));
        this.selectedRecordIdList = this.tableDataAll.map(i => i.easPayRecordId);
        this.pageTable();
        this.selectedRowKeys = [];
      }
    });
  }

  sumMessage: string = '合计金额： 0.00元';
  @Watch('tableDataAll')
  tableDataAllChange() {
    const sum = _.sumBy(this.tableDataAll, 'paidPrice');
    this.sumMessage = `合计金额：${this.numberRender(sum)}元`;
  }

  numberRender(value: number) {
    if (isNaN(value)) {
      return value;
    } else {
      const num = (value / 100).toFixed(2);
      return num.replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,');
    }
  }

  // 提交
  submitting: boolean = false;
  submitInfo() {
    if (this.submitting) return;
    this.form.validateFields(
      (
        err: any,
        values: {
          amounts: number;
          parkId: { value: any };
          bankReceiptNo: any;
          receiptTime: { format: (arg0: string) => any };
          remark: any;
          attachFileUrl: any;
        }
      ) => {
        console.log('Received values of form: ', values);
        if (!err) {
          //验证金额
          const sum0 = Math.round(values.amounts * 100);
          const sum = _.sumBy(this.tableDataAll, 'paidPrice');
          if (sum0 != sum) {
            this.$message.error('银行回单金额不等于缴费记录金额，请重新选择！');
            return;
          }

          const param = {
            easPayRecordIdList: this.selectedRecordIdList,
            checkDepositRecord: {
              parkId: values.parkId.value,
              bankReceiptNo: values.bankReceiptNo,
              projectBankId: this.selectedBank.id,
              amounts: Math.round(values.amounts * 100),
              receiptTime: moment.isMoment(values.receiptTime) ? values.receiptTime.format('YYYY-MM-DD 00:00:00') : '',
              remark: values.remark,
              attachFileUrl: values.attachFileUrl
            }
          };
          this.submitting = true;
          api
            .addDepositOfCash(param)
            .then((res: any) => {
              this.submitting = false;
              this.$message.success('新增成功');
              this.goBack();
            })
            .catch((err: { msg: any }) => {
              this.submitting = false;
              this.$message.error((err && err.msg) || '系统异常');
            });
        }
      }
    );
  }

  async created() {
    this.initForm();
  }
}
